import { NavLink, useLocation } from "react-router-dom";
import { cn } from "@/utils/cn";
import { ReactNode } from "react";

const Menu: React.FC<{
  active: boolean;
  icon: string;
  children: ReactNode;
}> = ({ active, children }) => (
  <>
    <div
      className={cn(
        "py-2 text-xl font-bold ",
        active && " underline-offset-8 underline"
      )}
    >
      <span className="block transition-opacity duration-200 group-hover:opacity-90">
        {children}
      </span>
    </div>
  </>
);

const MenuButton: React.FC<{
  route: string;
  icon: string;
  children: string;
}> = ({ icon, route, children }) => {
  const { pathname } = useLocation();
  const active =
    route === pathname ||
    (route === "/region" &&
      (pathname === "/pheno/western" ||
        pathname === "/pheno/central" ||
        pathname === "/pheno/eastern" ||
        pathname === "/pheno/gobi")) ||
    (route === "/pheno/cities" &&
      (pathname === "/pheno/erdenet" ||
        pathname === "/pheno/darkhan" ||
        pathname === "/pheno/ulaanbaatar")) ||
    (route === "/wind/all" && pathname.startsWith("/wind")) ||
    (route === "/forecast/ulaanbaatar" && pathname.startsWith("/forecast"));

  if (route === "alert") {
    return (
      <div
        className={cn(
          "group cursor-pointer relative flex items-center text-white uppercase"
        )}
      >
        <Menu icon={icon} active={active}>
          {children}
        </Menu>
      </div>
    );
  }
  return (
    <NavLink
      to={route}
      className={cn(
        "group cursor-pointer relative flex items-center text-white uppercase "
      )}
    >
      <Menu icon={icon} active={active}>
        {children}
      </Menu>
    </NavLink>
  );
};

export default MenuButton;
